import restApi from '../http-common';
import session from "../services/session";

export default class AdminApi {

    signIn(model) {
        return restApi({
            method: 'post',
            url: '/auth/login',
            data: {
                username: model.email,
                password: model.password
            }
        });
    }


    createUser(model) {
        return restApi({
            method: 'post',
            url: '/api/couriers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    updateDriver(model, id) {
        return restApi({
            method: 'put',
            url: '/api/couriers/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    updateFreeDays(model, id) {
        return restApi({
            method: 'patch',
            url: '/api/couriers/'+ id +'/free-days',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    createCompany(model) {
        return restApi({
            method: 'post',
            url: '/api/companies',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                name: model.name,
                internalName: model.internalName,
                visibleForCustomer: model.visibleForCustomer,
                phoneNumber: model.phoneNumber,
                lat: model.lat,
                lng: model.lng,
                usingVouchers: model.usingVouchers,
                info: model.info,
                discounts: model.discounts
            }
        });
    }

    uploadImage(companyId, file) {
        let formData = new FormData();
        formData.append("file", file);
        return restApi({
            method: 'patch',
            url: '/api/companies/'+ companyId +'/profile-image',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
                'Content-Type': 'multipart/form-data',
            },
            data: formData
        });
    }

    editCompany(model, id) {
        return restApi({
            method: 'put',
            url: '/api/companies/'+id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                name: model.name,
                internalName: model.internalName,
                visibleForCustomer: model.visibleForCustomer,
                phoneNumber: model.phoneNumber,
                lat: model.lat,
                lng: model.lng,
                usingVouchers: model.usingVouchers,
                info: model.info,
                discounts: model.discounts
            }
        });
    }


    updateCompany(model, id) {
        return restApi({
            method: 'put',
            url: '/api/companies/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                name: model.name,
                lat: model.lat,
                lng: model.lng
            }
        });
    }

    resendNotificationToCourier(orderId){
        return restApi({
            method: 'post',
            url: '/api/orders/' + orderId +'/notifications',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });
    }



    deleteCompany(id) {
        return restApi({
            method: 'delete',
            url: '/api/companies/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deactivateDriver(driverId, active) {
        return restApi({
            method: 'patch',
            url: '/api/couriers/' + driverId + "/active",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                active: active
            },
        })
    }


    getCompanies() {
        return restApi({
            method: 'get',
            url: '/api/companies',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    createCompanyStuff(model,companyId) {
        return restApi({
            method: 'post',
            url: '/api/companies/' +  companyId +'/staff',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                firstName: model.firstName,
                lastName: model.lastName,
                username: model.username,
                password: model.password
            }
        });
    }

    getCompanyStuffs(companyId) {
        return restApi({
            method: 'get',
            url: '/api/companies/' +  companyId +'/staff',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteCompanyStuff(id, companyId) {
        return restApi({
            method: 'delete',
            url: '/api/companies/'+ companyId +'/staff/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    getDrivers(activeParams, archived) {
        var archiveParam = '';
        if(archived == null) archiveParam = '&archived=false'
        var params = activeParams.length === 0 ? '?populate=false' + archiveParam : activeParams + '&populate=false' + archiveParam
        return restApi({
            method: 'get',
            url: '/api/couriers' + params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteDriver(id) {
        return restApi({
            method: 'delete',
            url: '/api/couriers/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    archiveDriver(courierId, archived) {
        return restApi({
            method: 'patch',
            url: '/api/couriers/'+courierId+'/archived',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                archived : archived,
            }
        });
    }

    getRecommendation(orderId) {
        return restApi({
            method: 'get',
            url: '/api/orders/' + orderId + "/courier",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addOrder(model) {
        return restApi({
            method: 'post',
            url: '/api/orders',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    updateOrderStatus(orderId, status) {
        return restApi({
            method: 'patch',
            url: '/api/orders/' + orderId + '/status',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                status : status,
            }
        });
    }


    connectDriver(orderId, driverId) {
        return restApi({
            method: 'patch',
            url: '/api/orders/' + orderId + "/courier",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                courier: driverId
            },
        })
    }

    updateOrder(model, id) {
        return restApi({
            method: 'put',
            url: '/api/orders/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    getOrders(activeParams, dateParams) {
        return restApi({
            method: 'get',
            url: '/api/orders' + activeParams + dateParams,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getOrderIntegration(orderId) {
        return restApi({
            method: 'get',
            url: '/api/integration/orders/' + orderId,
            headers: {
                // 'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    deleteOrder(id) {
        return restApi({
            method: 'delete',
            url: '/api/orders/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }



    getVehicles() {
        return restApi({
            method: 'get',
            url: '/api/vehicles',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    createVehicle(model) {
        return restApi({
            method: 'post',
            url: '/api/vehicles',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    editVehicle(model, id) {
        return restApi({
            method: 'put',
            url: '/api/vehicles/'+id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    deleteVehicle(id) {
        return restApi({
            method: 'delete',
            url: '/api/vehicles/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    createVehicleCost(model, vehicleId) {
        return restApi({
            method: 'post',
            url: '/api/vehicles/'+ vehicleId +'/expenses',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    editVehicleCost(model, vehicleId, id) {
        return restApi({
            method: 'put',
            url: '/api/vehicles/'+vehicleId+'/expenses/'+id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    deleteVehicleCost(vehicleId, id) {
        return restApi({
            method: 'delete',
            url: '/api/vehicles/'+vehicleId+'/expenses/'+id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getVehiclesCosts(vehicleId) {
        return restApi({
            method: 'get',
            url: '/api/vehicles/'+ vehicleId +'/expenses',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSchedules(dateParams) {
        return restApi({
            method: 'get',
            url: '/api/schedules' + dateParams+"&withOrders=false",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getScheduleImages(id) {
        return restApi({
            method: 'get',
            url: '/api/schedules/'+ id +'/images',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSchedulesReport(dateParams) {
        return restApi({
            method: 'get',
            url: '/api/schedules/reports' + dateParams,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    createSchedules(model) {
        return restApi({
            method: 'post',
            url: '/api/schedules',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    deleteSchedule(id) {
        return restApi({
            method: 'delete',
            url: '/api/schedules/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    startSchedule(id, model) {
        return restApi({
            method: 'patch',
            url: '/api/schedules/' + id +'/startTime',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    changeCourierStartTime(id, model) {
        return restApi({
            method: 'patch',
            url: '/api/couriers/'+ id +'/start-time',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }


    stopSchedule(id,model) {
        return restApi({
            method: 'patch',
            url: '/api/schedules/' + id +'/completionTime',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }



    completeSchedule(id, model) {
        return restApi({
            method: 'post',
            url: '/api/schedules/' + id + '/complete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                salary: model.salary,
                costs: model.cost,
                expense: model.expense,
                voucher: model.voucher,
                completionTime: model.completionTime
            }
        });
    }

    getDispatcherAdminMe() {
        let url =  session.getRole() === 'DISPATCHER' ? '/api/dispatchers/me' : '/api/admins/me';
        return restApi({
            method: 'get',
            url: url,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateDispatchersAndAdmin(model) {
        let url =  session.getRole() === 'DISPATCHER' ? '/api/dispatchers/me' : '/api/admins/me';
        return restApi({
            method: 'put',
            url: url,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }

    getOrderReport(dateParams) {
        return restApi({
            method: 'get',
            url: '/api/orders/count' + dateParams,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getVoucherHistory(param) {
        return restApi({
            method: 'get',
            url: '/api/companies/vouchers' + param,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    resetCompanyVoucher(companyId) {
        return restApi({
            method: 'delete',
            url: 'api/companies/'+ companyId +'/vouchers/values',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteVoucherById(companyId, voucherId) {
        return restApi({
            method: 'delete',
            url: 'api/companies/' + companyId + '/vouchers/' + voucherId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    //ADRESE I CENOVNIK

    getRegions() {
        return restApi({
            method: 'get',
            url: '/api/addresses/neighborhoods',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateRegion(model, id) {
        return restApi({
            method: 'put',
            url: '/api/addresses/neighborhoods/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    createRegion(model){
        return restApi({
            method: 'post',
            url: '/api/addresses/neighborhoods',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    deleteRegion(id){
        return restApi({
            method: 'delete',
            url: '/api/addresses/neighborhoods/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    createAddress(model){
        return restApi({
            method: 'post',
            url: '/api/addresses/streets',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    updateAddress(model, id) {
        return restApi({
            method: 'put',
            url: '/api/addresses/streets/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    deleteAddress(id){
        return restApi({
            method: 'delete',
            url: '/api/addresses/streets/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getAddresses() {
        console.log("Get address")
        return restApi({
            method: 'get',
            url: '/api/addresses/streets',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getBugs() {
        return restApi({
            method: 'get',
            url: '/api/reports',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getRates() {
        return restApi({
            method: 'get',
            url: '/api/reviews',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCourierRate(courierId) {
        return restApi({
            method: 'get',
            url: '/api/couriers/rates?courierId='+courierId,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getCourierRates(from, to) {
        return restApi({
            method: 'get',
            url: '/api/couriers/rates/report?fromTimestamp='+from +'&toTimestamp='+to,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    fixBug(id) {
        return restApi({
            method: 'patch',
            url: '/api/reports/'+ id +'/resolved',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
        })
    }


    //Dispeceri

    createDispatcher(model){
        return restApi({
            method: 'post',
            url: '/api/dispatchers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    updateDispatcher(model, id) {
        return restApi({
            method: 'put',
            url: '/api/dispatchers/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    deleteDispatcher(id){
        return restApi({
            method: 'delete',
            url: '/api/dispatchers/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getDispatchers() {
        return restApi({
            method: 'get',
            url: '/api/dispatchers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }



    getConfiguration() {
        return restApi({
            method: 'get',
            url: '/api/configuration',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateConfiguration(model, id) {
        return restApi({
            method: 'put',
            url: '/api/configuration',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    updateFuelPrices(model) {
        return restApi({
            method: 'post',
            url: '/api/fuel-prices',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    getCurrenFuelPrice(){
        return restApi({
            method: 'get',
            url: '/api/fuel-prices?onlyCurrent=true',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    editVehicleSchedule(model, id) {
        return restApi({
            method: 'patch',
            url: '/api/schedules/'+ id +'/vehicle',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    editStartShiftSchedule(model, id) {
        return restApi({
            method: 'patch',
            url: 'api/schedules/'+ id +'/startShift',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    addVoucherToCompany(companyId, model) {
        return restApi({
            method: 'put',
            url: '/api/companies/'+ companyId+'/vouchers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    addEfakturaToVoucherCompany(companyId,voucherId, model){
        return restApi({
            method: 'patch',
            url: '/api/companies/'+companyId+'/vouchers/'+voucherId+'/invoice',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }

    addVoucherToOrder(orderId, model) {
        return restApi({
            method: 'put',
            url: 'api/orders/'+ orderId +'/vouchers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        })
    }


    getVersions() {
        return restApi({
            method: 'get',
            url: 'api/versions',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addVersions(model){
        return restApi({
            method: 'post',
            url: 'api/versions',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model,
        })
    }

    deleteVersion(id) {
        return restApi({
            method: 'delete',
            url: '/api/versions/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }



    //CUSTOMERS

    getCustomers() {
        return restApi({
            method: 'get',
            url: '/api/customers',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }


    //MAILS

    sendMail(model) {
        return restApi({
            method: 'post',
            url: '/api/mails',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: model
        });
    }


    //VACATIONS

    getAllVacations(from,to) {
        return restApi({
            method: 'get',
            url: '/api/couriers/rests?fromTimestamp='+from+'&toTimestamp='+to,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getRequestedVacations() {
        return restApi({
            method: 'get',
            url: '/api/couriers/rests/filtered?status=REQUESTED',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateVacation(id, status, notes) {
        return restApi({
            method: 'patch',
            url: '/api/couriers/rests/'+id+'/status',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                status: status,
                notes: notes
            }
        });
    }

    deleteVacation(id) {
        return restApi({
            method: 'delete',
            url: '/api/couriers/rests',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                ids: [
                    id
                ]
            }
        })
    }



    // NOT USED

    acceptTerms() {
        return restApi({
            method: 'put',
            url: '/users/accept-terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });
    }

    changePassword(model) {
        return restApi({
            method: 'post',
            url: '/',
            data: {
                password: model.password,
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });
    }

    getUsers(model) {
        return restApi({
            method: 'get',
            url: '/users',
            params: {
                page: model.page,
                limit: model.limit,
                debtor: model.debtor,
                filter: model.filter
            },
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteUser(id) {
        return restApi({
            method: 'delete',
            url: '/users/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    registerUser(model) {
        return restApi({
            method: 'post',
            url: '/users',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getUser(id) {
        return restApi({
            method: 'get',
            url: '/users/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateUser(model, id) {
        return restApi({
            method: 'put',
            url: '/admin/users/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getPaymentByDate(model) {
        return restApi({
            method: 'get',
            url: '/payment',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate

            }
        })
    }

    getPayment(id) {
        return restApi({
            method: 'get',
            url: '/payment/user/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getPaymentById(id) {
        return restApi({
            method: 'get',
            url: '/payment/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addPayment(model) {
        return restApi({
            method: 'post',
            url: '/payment',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updatePayment(model, id) {
        return restApi({
            method: 'put',
            url: '/payment/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deletePayment(id) {
        return restApi({
            method: 'delete',
            url: '/payment/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getProfile() {
        return restApi({
            method: 'get',
            url: '/users/me',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateProfile(model) {
        return restApi({
            method: 'put',
            url: '/users',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTerms() {
        return restApi({
            method: 'get',
            url: '/terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTerm(model) {
        return restApi({
            method: 'post',
            url: '/terms',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTerm(id) {
        return restApi({
            method: 'delete',
            url: '/terms/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTerms(ids) {
        return restApi({
            method: 'delete',
            url: '/delete-terms',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            data: {
                ids: ids
            }
        })
    }

    getTermsById(id) {
        return restApi({
            method: 'get',
            url: '/terms/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTerm(model, id) {
        return restApi({
            method: 'put',
            url: '/terms/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSlotByDate(date) {
        return restApi({
            method: 'get',
            url: '/slots',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                date: date
            }
        })
    }

    addSlot(model) {
        return restApi({
            method: 'post',
            url: '/slots',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteSlot(id) {
        return restApi({
            method: 'delete',
            url: '/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deactivatedSlot(id) {
        return restApi({
            method: 'delete',
            url: '/deactivate/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    activatedSlot(id) {
        return restApi({
            method: 'put',
            url: '/activate/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getSlotById(id) {
        return restApi({
            method: 'get',
            url: '/slots/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateSlot(model, id) {
        return restApi({
            method: 'put',
            url: '/slots/' + id,
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addTraining(model) {
        return restApi({
            method: 'post',
            url: '/training',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTraining(id) {
        return restApi({
            method: 'delete',
            url: '/training/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    deleteTrainingAndRevertToUser(id) {
        return restApi({
            method: 'delete',
            url: 'revert/training/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingsByDate(date) {
        return restApi({
            method: 'get',
            url: '/training',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                date: date
            }
        })
    }

    getTrainingTypes() {
        return restApi({
            method: 'get',
            url: '/training/types',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    getTrainingsReport(model) {
        return restApi({
            method: 'get',
            url: '/admin/training',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                page: model.page,
                limit: model.limit,
                filter: model.filter
            }
        })
    }

    getSlotReport(model) {
            return restApi({
                method: 'get',
                url: '/slots/report',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
                },
                params: {
                    fromDate: model.fromDate,
                    toDate: model.toDate,
                    filter: model.filter
                }
            })
    }

    getSlotReportTrainer(model) {
        return restApi({
            method: 'get',
            url: '/slots/report/trainer',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            },
            params: {
                fromDate: model.fromDate,
                toDate: model.toDate,
                filter: model.filter
            }
        })
    }

    getNotification(model) {
        return restApi({
            method: 'get',
            url: '/notifications',
            params: {
                company: model
            }
        })
    }

    deleteNotifications(id) {
        return restApi({
            method: 'delete',
            url: '/notifications/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNotification(model) {
        return restApi({
            method: 'post',
            url: '/notifications',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    resetPassword(model) {
        return restApi({
            method: 'patch',
            url: '/users/password',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    resetUserPassword(id) {
        return restApi({
            method: 'patch',
            url: '/users/' + id + '/reset-password',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    openSlots(model) {
        return restApi({
            method: 'post',
            url: '/open/slots',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    plusTraining(id) {
        return restApi({
            method: 'put',
            url: '/training/plus/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    minusTraining(id) {
        return restApi({
            method: 'put',
            url: '/training/minus/' + id,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addKey(model) {
        return restApi({
            method: 'put',
            url: '/training/key',
            data: model,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    addNotArrival(userId) {
        return restApi({
            method: 'post',
            url: '/user/' + userId +'/add-not-arrival',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    removeNotArrival(userId) {
        return restApi({
            method: 'post',
            url: '/user/' + userId +'/remove-not-arrival',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        })
    }

    updateTrainingTypes(model, userId){
    return restApi({
        method: 'put',
        url: '/user/'+ userId +'/training-types',
        data: model,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
        }
        })
    }


}



// WEBPACK FOOTER //
// ./src/services/api.js